
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.13.0
 * Query Engine version: b9a39a7ee606c28e3455d0fd60e78c3ba82b1a2b
 */
Prisma.prismaVersion = {
  client: "5.13.0",
  engine: "b9a39a7ee606c28e3455d0fd60e78c3ba82b1a2b"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  uid: 'uid',
  email: 'email',
  name: 'name',
  emailVerified: 'emailVerified',
  profileCompletedAt: 'profileCompletedAt',
  image: 'image',
  displayName: 'displayName',
  aboutMe: 'aboutMe',
  location: 'location',
  url: 'url',
  ikuraplus: 'ikuraplus',
  ikuraplusStartedAt: 'ikuraplusStartedAt',
  isAdmin: 'isAdmin',
  verifiedOwner: 'verifiedOwner',
  businessTags: 'businessTags',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.PlaceScalarFieldEnum = {
  id: 'id',
  googlePlaceId: 'googlePlaceId',
  name: 'name',
  description: 'description',
  types: 'types',
  lat: 'lat',
  lng: 'lng',
  imagesCachedAt: 'imagesCachedAt',
  locationImageUrl: 'locationImageUrl',
  formattedAddress: 'formattedAddress',
  addressComponents: 'addressComponents',
  popularPlace: 'popularPlace',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PlaceAffiliateScalarFieldEnum = {
  id: 'id',
  placeId: 'placeId',
  position: 'position',
  type: 'type',
  url: 'url',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GoogleImageScalarFieldEnum = {
  id: 'id',
  photoReference: 'photoReference',
  htmlAttributions: 'htmlAttributions',
  objectId: 'objectId',
  cachedUrl: 'cachedUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  placeId: 'placeId'
};

exports.Prisma.ListScalarFieldEnum = {
  id: 'id',
  name: 'name',
  normalizedName: 'normalizedName',
  slug: 'slug',
  description: 'description',
  userId: 'userId',
  visibility: 'visibility',
  collaborationKey: 'collaborationKey',
  sharingKey: 'sharingKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  photos: 'photos',
  priority: 'priority'
};

exports.Prisma.ListTagScalarFieldEnum = {
  id: 'id',
  listId: 'listId',
  tagId: 'tagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  title: 'title',
  description: 'description',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SharedUsersOnListsScalarFieldEnum = {
  id: 'id',
  listId: 'listId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FollowersOnListsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  listId: 'listId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CollaboratorsOnListsScalarFieldEnum = {
  id: 'id',
  listId: 'listId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SpotScalarFieldEnum = {
  id: 'id',
  listId: 'listId',
  placeId: 'placeId',
  userId: 'userId',
  name: 'name',
  normalizedName: 'normalizedName',
  slug: 'slug',
  comment: 'comment',
  position: 'position',
  priority: 'priority',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SpotImageScalarFieldEnum = {
  id: 'id',
  objectId: 'objectId',
  cachedUrl: 'cachedUrl',
  spotId: 'spotId',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SpotTagScalarFieldEnum = {
  id: 'id',
  spotId: 'spotId',
  tagId: 'tagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserSpotVisitScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  spotId: 'spotId',
  comment: 'comment',
  visitedAt: 'visitedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserSpotFavScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  spotId: 'spotId',
  favedAt: 'favedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserPlaceSaveScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  placeId: 'placeId',
  savedAt: 'savedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TripScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  description: 'description',
  startDate: 'startDate',
  days: 'days',
  popularPlanId: 'popularPlanId',
  desiredDestinations: 'desiredDestinations',
  withWhom: 'withWhom',
  conditions: 'conditions',
  ideaText: 'ideaText',
  entryPlace: 'entryPlace',
  exitPlace: 'exitPlace',
  aiInCreating: 'aiInCreating',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TripDayScalarFieldEnum = {
  id: 'id',
  tripId: 'tripId',
  nthDay: 'nthDay',
  title: 'title',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aiSuggestedPlans: 'aiSuggestedPlans',
  aiSuggestedPlaces: 'aiSuggestedPlaces',
  transportation: 'transportation',
  stayPlaceId: 'stayPlaceId',
  accommodationPlace: 'accommodationPlace',
  region: 'region'
};

exports.Prisma.TripItemScalarFieldEnum = {
  id: 'id',
  tripDayId: 'tripDayId',
  position: 'position',
  type: 'type',
  title: 'title',
  spotId: 'spotId',
  note: 'note',
  placeId: 'placeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PopularPlanScalarFieldEnum = {
  id: 'id',
  title: 'title',
  position: 'position',
  description: 'description',
  places: 'places',
  note: 'note',
  suggestedMinimumDays: 'suggestedMinimumDays',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InquiryScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  placeId: 'placeId',
  spotId: 'spotId',
  text: 'text',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExperienceScalarFieldEnum = {
  id: 'id',
  position: 'position',
  type: 'type',
  title: 'title',
  shortBlub: 'shortBlub',
  description: 'description',
  duration: 'duration',
  cancellationPolicy: 'cancellationPolicy',
  guideLanguages: 'guideLanguages',
  meetingPointLat: 'meetingPointLat',
  meetingPointLng: 'meetingPointLng',
  meetingPointAltText: 'meetingPointAltText',
  includes: 'includes',
  excludes: 'excludes',
  notAllowed: 'notAllowed',
  knowBeforeYouGo: 'knowBeforeYouGo',
  priceAdult: 'priceAdult',
  priceChild: 'priceChild',
  priceInfant: 'priceInfant',
  stars: 'stars',
  reviewsCount: 'reviewsCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExperienceImageScalarFieldEnum = {
  id: 'id',
  objectId: 'objectId',
  cachedUrl: 'cachedUrl',
  experienceId: 'experienceId',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExperiencePlaceScalarFieldEnum = {
  id: 'id',
  experienceId: 'experienceId',
  placeId: 'placeId',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BookingExperienceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  experienceId: 'experienceId',
  date: 'date',
  tripId: 'tripId',
  numberOfAdults: 'numberOfAdults',
  numberOfChildren: 'numberOfChildren',
  numberOfInfants: 'numberOfInfants',
  unitAdultsPrice: 'unitAdultsPrice',
  unitChildrenPrice: 'unitChildrenPrice',
  unitInfantsPrice: 'unitInfantsPrice',
  totalAdultsPrice: 'totalAdultsPrice',
  totalChildrenPrice: 'totalChildrenPrice',
  totalInfantsPrice: 'totalInfantsPrice',
  totalPrice: 'totalPrice',
  status: 'status'
};

exports.Prisma.SaveScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  placeId: 'placeId',
  spotId: 'spotId',
  experienceId: 'experienceId',
  listId: 'listId',
  savedAt: 'savedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.AffiliateType = exports.$Enums.AffiliateType = {
  TRIPCOM: 'TRIPCOM',
  EXPEDIA: 'EXPEDIA',
  AGODA: 'AGODA',
  RAKUTEN: 'RAKUTEN',
  GETYOURGUIDE: 'GETYOURGUIDE',
  VIATOR: 'VIATOR',
  IKURAPLUS: 'IKURAPLUS',
  WEB: 'WEB'
};

exports.Visibility = exports.$Enums.Visibility = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC'
};

exports.TripItemType = exports.$Enums.TripItemType = {
  SPOT: 'SPOT',
  NOTE: 'NOTE',
  PLACE: 'PLACE'
};

exports.ExperiencePaymentStatus = exports.$Enums.ExperiencePaymentStatus = {
  REQUESTING: 'REQUESTING',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  CANCELED: 'CANCELED'
};

exports.SaveType = exports.$Enums.SaveType = {
  PLACE: 'PLACE',
  SPOT: 'SPOT',
  EXPERIENCE: 'EXPERIENCE',
  LIST: 'LIST'
};

exports.Prisma.ModelName = {
  User: 'User',
  Account: 'Account',
  Session: 'Session',
  VerificationToken: 'VerificationToken',
  Place: 'Place',
  PlaceAffiliate: 'PlaceAffiliate',
  GoogleImage: 'GoogleImage',
  List: 'List',
  ListTag: 'ListTag',
  Tag: 'Tag',
  SharedUsersOnLists: 'SharedUsersOnLists',
  FollowersOnLists: 'FollowersOnLists',
  CollaboratorsOnLists: 'CollaboratorsOnLists',
  Spot: 'Spot',
  SpotImage: 'SpotImage',
  SpotTag: 'SpotTag',
  UserSpotVisit: 'UserSpotVisit',
  UserSpotFav: 'UserSpotFav',
  UserPlaceSave: 'UserPlaceSave',
  Trip: 'Trip',
  TripDay: 'TripDay',
  TripItem: 'TripItem',
  PopularPlan: 'PopularPlan',
  Inquiry: 'Inquiry',
  Experience: 'Experience',
  ExperienceImage: 'ExperienceImage',
  ExperiencePlace: 'ExperiencePlace',
  BookingExperience: 'BookingExperience',
  Save: 'Save'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
